import angular from 'angular';

angular
  .module('message', [])

  .config([
    '$stateProvider',
    function($stateProvider) {
      $stateProvider
        .state('message', {
          data: {
            authorizedRole: 'USER_BO'
          }
        })
        .state('message_details', {
          url: '/message/{messageId:[0-9]+}',
          templateUrl: require('./message-details.html'),
          controller: 'MessageDetailsCtrl',
          resolve: {
            message: [
              '$transition$',
              'MessageService',
              function($transition$, MessageService) {
                return MessageService.get({ messageId: $transition$.params().messageId });
              }
            ]
          },
          data: {
            authorizedRole: 'USER_BO'
          }
        });
    }
  ]);
